export default {
    branch_break: {
        name: "Branch Break",
        url: "nwcg_assignment_break/branch_break",
    },
    branch_break_2: {
        name: "Branch Break",
        url: "nwcg_assignment_break/branch_break_2",
    },
    branch_break_3: {
        name: "Branch Break",
        url: "nwcg_assignment_break/branch_break_3",
    },
    branch_break_4: {
        name: "Branch Break",
        url: "nwcg_assignment_break/branch_break_4",
    },
    division_break: {
        name: "Division Break",
        url: "nwcg_assignment_break/division_break",
    },
    division_break_2: {
        name: "Division Break",
        url: "nwcg_assignment_break/division_break_2",
    },
    division_break_3: {
        name: "Division Break",
        url: "nwcg_assignment_break/division_break_3",
    },
    division_break_4: {
        name: "Division Break",
        url: "nwcg_assignment_break/division_break_4",
    },
    zone_break: {
        name: "Zone Break",
        url: "nwcg_assignment_break/zone_break",
    },
    zone_break_2: {
        name: "Zone Break",
        url: "nwcg_assignment_break/zone_break_2",
    },
    zone_break_3: {
        name: "Zone Break",
        url: "nwcg_assignment_break/zone_break_3",
    },
    zone_break_4: {
        name: "Zone Break",
        url: "nwcg_assignment_break/zone_break_4",
    },
}
